import API from "./api";

export async function getPrograms(projectId) {
    const res = await API.get(`/projects/${projectId}/programs`);
    return res.data;
}

export async function getProgram(projectId, id) {
    const res = await API.get(`/projects/${projectId}/programs/${id}`);
    return res.data;
}

export async function createProgram(projectId, payload) {
    const res = await API.post(`/projects/${projectId}/programs`, payload);
    return res.data;
}

export async function updateProgram(projectId, id, payload) {
    const res = await API.put(`/projects/${projectId}/programs/${id}`, payload);
    return res.data;
}

export async function deleteProgram(projectId, id) {
    await API.delete(`/projects/${projectId}/programs/${id}`);
}